<template>
<d2-container>
    <h2>司机管理</h2>
    <el-form ref="elForm" size="medium" label-width="120px">
        <el-row type="flex" justify="start" align="top">
            <el-form-item label="司机姓名" prop="dd">
                <el-input v-model="listQuery.name" placeholder="司机姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="司机标识" prop="dd">
                <el-input v-model="listQuery.uniqueId" placeholder="司机标识" clearable></el-input>
            </el-form-item>
        </el-row>
        <el-form-item size="large">
            <el-button size="small" class="filter-item" type="primary" icon="search" @click="handleFilter">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
        </el-form-item>
    </el-form>

    <el-button size="small" class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary" icon="edit">添加</el-button>

    <el-table :key='tableKey' :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row style="width: 100%">

        <el-table-column align="center" label="id" width="65">
            <template slot-scope="scope">
                <span>{{scope.row.id}}</span>
            </template>
        </el-table-column>
        <el-table-column align="center" label="标识">
            <template slot-scope="scope">
                <span>{{scope.row.uniqueId}}</span>
            </template>
        </el-table-column>
        <el-table-column align="center" label="司机姓名">
            <template slot-scope="scope">
                <span>{{scope.row.name}}</span>
            </template>
        </el-table-column>
        <el-table-column align="center" label="手机号">
            <template slot-scope="scope">
                <span>{{scope.row.phone}}</span>
            </template>
        </el-table-column>
        <el-table-column align="center" label="账号">
            <template slot-scope="scope">
                <span>{{scope.row.username}}</span>
            </template>
        </el-table-column>
        <el-table-column align="center" label="账户状态">
            <template slot-scope="scope">
                <span>{{scope.row.disabled==1?'禁用':'启用'}}</span>
            </template>
        </el-table-column>
        <el-table-column align="center" label="备注">
            <template slot-scope="scope">
                <span>{{scope.row.remark}}</span>
            </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="150"> <template slot-scope="scope">
                <el-button size="small" type="success" @click="handleUpdate(scope.row)">编辑
                </el-button>
                <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除
                </el-button>
            </template> </el-table-column>
    </el-table>
    <template slot="footer">
        <div v-show="!listLoading" class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
        </div>
    </template>
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item label="司机姓名" prop="name">
                <el-input v-model="form.name" placeholder="请输入司机姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="账号" prop="username">
                <el-input v-model="form.username" placeholder="请输入账号"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input v-model="form.password" show-password placeholder="请输入密码,不填则不更新原密码"></el-input>
            </el-form-item>
            <el-form-item label="账户状态" prop="disabled">
                <el-switch v-model="form.disabled" :active-value="0" :inactive-value="1" active-text="启用" inactive-text="禁用"></el-switch>
            </el-form-item>  
            <el-form-item label="操作车型" >
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <div style="margin: 15px 0;"></div>
                <el-checkbox-group v-model="form.modelIds" @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="model in carModelList" :label="model.value" :key="model.value">{{model.label}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input v-model="form.remark" placeholder="请输入备注"></el-input>
            </el-form-item>
        </el-form> 
        <div slot="footer" class="dialog-footer">  
            <el-button @click="cancel('form')" size="small">取 消</el-button>
            <el-button v-if="dialogStatus=='create'" size="small" type="primary" @click="create('form')">确 定</el-button>
            <el-button v-else type="primary" size="small" @click="update('form')">确 定</el-button>
        </div>
    </el-dialog>
</d2-container>
</template>

<script>
import {
    page,
    addObj,
    getObj,
    delObj,
    putObj
} from '@/api/admin/appCarDriver/index';
import {
    carModelList
} from '@/api/admin/sysCarModel/index';
import {
    mapGetters
} from 'vuex';
export default {
    name: 'appCarDriver',
    data() {
        return {
            checkAll: false,
            isIndeterminate:true,
            carModelList:[],
            checkedModelList:[],
            form: {
                uniqueId: undefined,
                name: undefined,
                headImg: undefined,
                phone: undefined,
                entId: undefined,
                username: undefined,
                password: undefined,
                disabled: undefined,
                isDel: undefined,
                modelIds:[],
            },
            rules: {
                name: [{
                    required: true,
                    message: '请输入姓名',
                    trigger: 'blur'
                }],
                phone: [{
                    required: true,
                    message: '请输入手机号',
                    trigger: 'blur'
                }],
                username: [{
                    required: true,
                    message: '请输入账号',
                    trigger: 'blur'
                }]
            },
            list: null,
            total: null,
            listLoading: true,
            listQuery: {
                page: 1,
                limit: 20,
                name: undefined
            },
            dialogFormVisible: false,
            dialogStatus: '',
            textMap: {
                update: '编辑',
                create: '创建'
            },
            tableKey: 0
        }
    },
    created() {
        this.getList();
        this.modelList();
    },
    computed: {
        ...mapGetters([
            'elements'
        ])
    },
    methods: {
        handleCheckAllChange(val) {
            this.form.modelIds = val ? this.carModelList.map(x=>x.value) : [];
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.carModelList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.carModelList.length;
        },
        modelList(){ 
            carModelList().then(res=>{
                this.carModelList = res;
                this.checkedModelList = res;
            });
        },
        getList() {
            this.listLoading = true;
            page(this.listQuery).then(response => {
                this.list = response.rows;
                this.total = response.total;
                this.listLoading = false;
            })
        },
        handleFilter() {
            this.getList();
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        handleCreate() {
            this.resetTemp();
            this.dialogStatus = 'create';
            this.dialogFormVisible = true;
        },
        handleUpdate(row) {
            getObj(row.id)
                .then(response => {
                    this.form = response;
                    this.dialogFormVisible = true;
                    this.dialogStatus = 'update';
                });
        },
        handleDelete(row) {
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(() => {
                    delObj(row.id)
                        .then(() => {
                            this.$notify({
                                title: '成功',
                                message: '删除成功',
                                type: 'success',
                                duration: 2000
                            });
                            const index = this.list.indexOf(row);
                            this.list.splice(index, 1);
                        });
                });
        },
        create(formName) {
            const set = this.$refs;
            set[formName].validate(valid => {
                if (valid) {
                    addObj(this.form)
                        .then(() => {
                            this.dialogFormVisible = false;
                            this.getList();
                            this.$notify({
                                title: '成功',
                                message: '创建成功',
                                type: 'success',
                                duration: 2000
                            });
                        })
                } else {
                    return false;
                }
            });
        },
        cancel(formName) {
            this.dialogFormVisible = false;
            const set = this.$refs;
            set[formName].resetFields();
        },
        update(formName) {
            const set = this.$refs;
            set[formName].validate(valid => {
                if (valid) {
                    this.dialogFormVisible = false;
                    addObj(this.form).then(() => {
                        this.dialogFormVisible = false;
                        this.getList();
                        this.$notify({
                            title: '成功',
                            message: '创建成功',
                            type: 'success',
                            duration: 2000
                        });
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm() {
            this.listQuery = {
                page: 1,
                limit: 20,
                name: undefined
            };
        },
        resetTemp(){
            this.form={
                uniqueId: undefined,
                name: undefined,
                headImg: undefined,
                phone: undefined,
                entId: undefined,
                username: undefined,
                password: undefined,
                disabled: undefined,
                isDel: undefined,
                modelList:[],
            }
        }
    }
}
</script>
